import { Injectable } from '@angular/core';
import * as _ from "lodash"

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsService {
  
  private featureFlags: Record<string, boolean>; 

  public ContainsFeatureFlag(flagName: string): boolean{
    return this.featureFlags[flagName];
  }

  public initialize(featureFlags: any){
    if (!this.featureFlags){
      this.featureFlags = {};
    }
    
    _.extend(this.featureFlags, featureFlags);
  }

}
